module.exports = function () {
    return new Worker(__webpack_public_path__ + "a6b2ade86e724ac8b301.worker.js");
};
